import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { ButtonGigi } from 'styles';
import { Loading, Template } from 'components';

const AdministrativoArquivoParaSuaFarmacia = () => {
  const [isLoading, setIsLoading] = useState(true);
  const history = useHistory();

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 500);
  }, []);

  return (
    <>
      {isLoading ? (
        <Loading />
      ) : (
        <Template>
          <div className='button-content'>
            <ButtonGigi
              bgColor='red'
              onClick={() =>
                history.push(
                  '/administrativo/arquivos/parasuafarmacia/geofusion'
                )
              }
            >
              ANÁLISE GEOFUSION
            </ButtonGigi>
            <ButtonGigi
              bgColor='red'
              onClick={() =>
                history.push(
                  '/administrativo/arquivos/parasuafarmacia/credenciamento'
                )
              }
            >
              CREDENCIAMENTO
            </ButtonGigi>
            <ButtonGigi
              bgColor='red'
              onClick={() =>
                history.push(
                  '/administrativo/arquivos/parasuafarmacia/implantacao'
                )
              }
            >
              IMPLANTAÇÃO
            </ButtonGigi>
          </div>
        </Template>
      )}
    </>
  );
};

export default AdministrativoArquivoParaSuaFarmacia;
